import { getOrderProductIdsForStoreWithRange } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useOrderProductsForStore = (storeId: string | null) => {
  const { data: orderProducts, isValidating: orderProductsLoading } = useSWRImmutable(
    storeId ? `orders/${storeId}` : null,
    getOrderProductIdsForStoreWithRange,
    {
      errorRetryCount: 2,
    }
  );

  return {
    orderProducts,
    orderProductsLoading,
  };
};

export default useOrderProductsForStore;
